module.exports = __webpack_public_path__ + "static/media/avocado.81ca84cb.png";